import Image from "next/image";

export const ProductItem = ({ src, title, lead, desc, sub, href }) => {
  return (
    <>
      <div className="col-span-1 space-y-2">
        {src && (
          <figure className="relative box-border block aspect-2.138/1 w-full border border-solid border-bdc-light">
            <Image
              src={src}
              alt={title}
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </figure>
        )}
        {lead && (
          <h4
            className="font-serif font-bold text-nvy fluid-text-[16px,22px]"
            dangerouslySetInnerHTML={{
              __html: `${lead}`,
            }}
          />
        )}
        {title && href && (
          <h3 className="font-bold text-pri fluid-text-[14px,18px]">
            <a
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              className="--tl --ff"
            >
              {title}
            </a>
          </h3>
        )}
        {title && !href && (
          <h3 className="font-bold text-pri fluid-text-[14px,18px]">{title}</h3>
        )}
        {desc && (
          <div className="grid-cols-1 leading-relaxed  text-txt-base fluid-text-[12px,14px]">
            <div
              dangerouslySetInnerHTML={{
                __html: `${desc}`,
              }}
            />
          </div>
        )}
        {sub && (
          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {sub.map(function (item) {
              return (
                <div key="{item.index}" className="col-span-1 w-full space-y-2">
                  <figure className="relative box-border block aspect-1/1 w-full border border-solid border-bdc-light bg-white">
                    <Image
                      src={item.src}
                      alt={item.title}
                      quality={80}
                      layout="fill"
                      objectFit="cover"
                    />
                  </figure>
                  <h3 className="font-bold text-pri fluid-text-[14px,18px]">
                    {item.title && item.href && (
                      <h3 className="font-bold text-pri fluid-text-[14px,18px]">
                        <a
                          href={item.href}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="--tl --ff"
                        >
                          {item.title}
                        </a>
                      </h3>
                    )}
                    {item.title && !item.href && (
                      <h3 className="font-bold text-pri fluid-text-[14px,18px]">
                        {item.title}
                      </h3>
                    )}
                  </h3>
                  <div
                    className="leading-relaxed text-txt-base fluid-text-[12px,14px] "
                    dangerouslySetInnerHTML={{
                      __html: `${item.desc}`,
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
